import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeadCell,
  TableRow,
} from "flowbite-react";
// compoenets
import { useNavigate } from "react-router-dom";
import {Eye} from 'lucide-react'

const BtachTable = ({ batches }) => {
  const navigate = useNavigate();

  const handleRowClick = (batch) => {
    console.log("Batch ID:", batch);
    navigate(`/batch/${batch._id}`, { state: batch });
  };

  const tableCells = [
    "Name",
    "Quantity",
    "First_iccid",
    "Last_iccid",
    "Provider",
    "Batch_Number",
    "Date",
    "Actions",
  ];

  return (
    <div className="overflow-x-auto">
      {batches?.length > 0 ? (
        <Table striped>
          <TableHead>
            {tableCells.map((feild, index) => {
              return <TableHeadCell key={index}>{feild}</TableHeadCell>;
            })}
          </TableHead>
          <TableBody className="divide-y">
            {batches?.map((batchInfo, index) => {
              return (
                <TableRow
                  onClick={() => handleRowClick(batchInfo)}
                  key={index}
                  className="bg-white dark:border-gray-700 dark:bg-gray-800 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700">
                  <TableCell className="font-bold">
                    {batchInfo?.batch_name}
                  </TableCell>
                  <TableCell className="text-blue-900">
                    {batchInfo?.quantity}
                  </TableCell>
                  <TableCell className="">{batchInfo?.first_iccid}</TableCell>
                  <TableCell>{batchInfo?.last_iccid}</TableCell>
                  <TableCell>{batchInfo?.provider}</TableCell>
                  <TableCell>{batchInfo?.batch_number.slice(0, 10)}</TableCell>
                  <TableCell>{batchInfo?.created_at.slice(0, 10)}</TableCell>
                  <TableCell>
                    <Eye size={18} />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      ) : (
        <div className="p-2 dark:text-white">Aucun batch trouvé</div>
      )}
    </div>
  );
};

export default BtachTable;
